import { createReducer } from 'helpers/redux';
import { INCREMENT_INTERACTIONS, RESET_TAGGING } from './types';

export const initialState = {
  interactions: {
    colours: 0,
    accessories: 0,
    packs: 0,
    extras: 0,
    total: 0,
  },
};

const taggingReducer = createReducer({
  initialState,
  reducers: {
    [INCREMENT_INTERACTIONS]: (state, { payload: metric }) => ({
      ...state,
      interactions: {
        ...state.interactions,
        [metric]: state.interactions[metric] + 1,
      },
    }),
    [RESET_TAGGING]: () => ({
      ...initialState,
    }),
  },
});

export default taggingReducer;
